import { WIDGET_DESIGN_CHOICE } from '@/constants/enum';
import { Box, Card, Divider, Tabs } from '@shopify/polaris';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { WidgetDesignAdavanced } from './component/WidgetDesignAdavanced';
import { WidgetDesignColour } from './component/WidgetDesignColour';
import { WidgetDesignGeneral } from './component/WidgetDesignGeneral';
import { WidgetDesignTextField } from './component/WidgetDesignTextField';

const WidgetDesign = () => {
  const { t } = useTranslation('widget_settings');
  const [widgetDesignChoice, setWidgetDesignChoice] = useState(0);

  const handleTabChange = useCallback((selectedTabIndex: number) => setWidgetDesignChoice(selectedTabIndex), []);

  const tabs = [
    {
      id: 'widget-general-setting',
      content: t('widgetDesign.choice.0'),
      accessibilityLabel: 'Widget general setting',
      panelID: 'widget-general-setting',
    },
    {
      id: 'widget-textfield-setting',
      content: t('widgetDesign.choice.1'),
      accessibilityLabel: 'Widget textfield setting',
      panelID: 'widget-textfield-setting',
    },
    {
      id: 'widget-colour-setting',
      content: t('widgetDesign.choice.2'),
      panelID: 'widget-colour-setting',
    },
    {
      id: 'widget-advanced-setting',
      content: t('widgetDesign.choice.3'),
      panelID: 'widget-advanced-setting',
    },
  ];

  return (
    <Card padding={'0'}>
      <Tabs tabs={tabs} selected={widgetDesignChoice} onSelect={handleTabChange} />
      <Box paddingBlockStart={'100'}>
        <Divider borderColor="border" />
      </Box>
      {widgetDesignChoice === WIDGET_DESIGN_CHOICE.GENERAL && <WidgetDesignGeneral />}
      {widgetDesignChoice === WIDGET_DESIGN_CHOICE.TEXTFIELD && <WidgetDesignTextField />}
      {widgetDesignChoice === WIDGET_DESIGN_CHOICE.COLOUR && <WidgetDesignColour />}
      {widgetDesignChoice === WIDGET_DESIGN_CHOICE.ADVANCED && <WidgetDesignAdavanced />}
    </Card>
  );
};

export default WidgetDesign;
